/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  RiskOverviewCategory,
  RiskOverviewCategory$inboundSchema,
} from "./riskoverviewcategory.js";
import {
  RiskOverviewTimeSeriesFinding,
  RiskOverviewTimeSeriesFinding$inboundSchema,
} from "./riskoverviewtimeseriesfinding.js";
import {
  RiskOverviewUser,
  RiskOverviewUser$inboundSchema,
} from "./riskoverviewuser.js";
import {
  RiskRuleBreakdownEntry,
  RiskRuleBreakdownEntry$inboundSchema,
} from "./riskrulebreakdownentry.js";

export type RiskOverviewResult = {
  /**
   * Policy findings in the window.
   */
  findings: number;
  /**
   * Chat sessions with at least one finding in the window.
   */
  flaggedSessions: number;
  /**
   * Inclusive start of the overview window.
   */
  from: Date;
  /**
   * Time-series finding counts by category in the window.
   */
  timeSeriesFindings: Array<RiskOverviewTimeSeriesFinding>;
  /**
   * Exclusive end of the overview window.
   */
  to: Date;
  /**
   * Top policy categories by finding count.
   */
  topCategories: Array<RiskOverviewCategory>;
  /**
   * Top rule_ids by finding count.
   */
  topRules: Array<RiskRuleBreakdownEntry>;
  /**
   * Top users by finding count.
   */
  topUsers: Array<RiskOverviewUser>;
};

/** @internal */
export const RiskOverviewResult$inboundSchema: z.ZodMiniType<
  RiskOverviewResult,
  unknown
> = z.pipe(
  z.object({
    findings: z.int(),
    flagged_sessions: z.int(),
    from: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    time_series_findings: z.array(RiskOverviewTimeSeriesFinding$inboundSchema),
    to: z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
    top_categories: z.array(RiskOverviewCategory$inboundSchema),
    top_rules: z.array(RiskRuleBreakdownEntry$inboundSchema),
    top_users: z.array(RiskOverviewUser$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "flagged_sessions": "flaggedSessions",
      "time_series_findings": "timeSeriesFindings",
      "top_categories": "topCategories",
      "top_rules": "topRules",
      "top_users": "topUsers",
    });
  }),
);

export function riskOverviewResultFromJSON(
  jsonString: string,
): SafeParseResult<RiskOverviewResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RiskOverviewResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RiskOverviewResult' from JSON`,
  );
}
